import { Box, Stack } from "@mui/material";
import SubdirectoryArrowRightRoundedIcon from "@mui/icons-material/SubdirectoryArrowRightRounded";
import React from "react";
import theme from "Theme/AppTheme";
import { ConversationComment } from "services/ConversationService";
import RepliesList from "./RepliesList";

type CommentItemProps = {
    comment: ConversationComment;
    isChat: boolean;
    replies: ConversationComment[];
    isReplying: boolean;
    replyComposer: React.ReactNode;
    editComposer: React.ReactNode;
    replyEditComposer: React.ReactNode;
    replyEditCommentId: string | null;
    renderCommentContent: (
        comment: ConversationComment,
        options: { showTimestamp: boolean; editComposer?: React.ReactNode },
    ) => React.ReactNode;
    onReplyClick: (commentId: string) => void;
};

const CommentItem = React.memo(
    ({
        comment,
        isChat,
        replies,
        isReplying,
        replyComposer,
        editComposer,
        replyEditComposer,
        replyEditCommentId,
        renderCommentContent,
        onReplyClick,
    }: CommentItemProps) => (
        <Box key={comment.id} id={comment.id ? `comment-${comment.id}` : ""}>
            <Stack spacing={1.5}>
                {renderCommentContent(comment, {
                    showTimestamp: !isChat,
                    editComposer,
                })}
                {comment.id && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        <Box
                            component="button"
                            type="button"
                            onClick={() => onReplyClick(comment.id!)}
                            sx={{
                                border: "none",
                                background: "none",
                                padding: 0,
                                margin: 0,
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                                cursor: "pointer",
                                fontSize: "13px",
                            }}
                        >
                            Reply
                        </Box>
                    </Box>
                )}
                {replies.length > 0 && (
                    <RepliesList
                        replies={replies}
                        renderCommentContent={renderCommentContent}
                        activeEditCommentId={replyEditCommentId}
                        editComposer={replyEditComposer}
                    />
                )}
                {isReplying ? (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                            paddingLeft: 3,
                        }}
                    >
                        <SubdirectoryArrowRightRoundedIcon
                            sx={{
                                color: theme.palette.gray[400],
                                fontSize: "18px",
                                marginTop: "2px",
                                flexShrink: 0,
                            }}
                        />
                        <Box sx={{ flex: 1 }}>{replyComposer}</Box>
                    </Box>
                ) : null}
            </Stack>
        </Box>
    ),
);

export default CommentItem;
